var map = {
	"./ashColor1.jpg": 57,
	"./barkAndLight.jpg": 58,
	"./blossomsAndLeafs.jpg": 59,
	"./cmuBuilding.jpg": 60,
	"./crabappleBlossoms.jpg": 61,
	"./depotTownClock.jpg": 62,
	"./duckTrails.jpg": 63,
	"./fascadeDepotTown.jpg": 64,
	"./littleBigWave.jpg": 65,
	"./oneWay.jpg": 66,
	"./osroColor2.jpg": 67,
	"./overpass1.jpg": 68,
	"./overpass2.jpg": 69,
	"./petalsInHand.jpg": 70,
	"./stellaColor1.jpg": 71,
	"./stellaColor3.jpg": 72,
	"./twigsAndLight.jpg": 73,
	"./wetCrabappleBlossoms.jpg": 74,
	"./yellowHydrant.jpg": 75,
	"./ypsiParkBridge.jpg": 76,
	"./zilwaukeBridge.jpg": 77
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;